<div class="container">
  <div class=" ">
    <div class="col-md-12" style="white-space: nowrap">
      <h2 class="pt-3 float-left">Manage OT</h2>
      <div class="float-right pt-3">
        <button
          mat-flat-button
          [routerLink]="['/OT-assign']"
          class="normal-button"
        >
          <span>Assign OT</span>
        </button>
      </div>
    </div>
    <div>
      <!-- <div class="col-lg-3 col-md-3 col-sm-12">
          <mat-form-field class="full-width" appearance="outline" floatLabel="always">
            <mat-label>Date</mat-label>
            <input
              matInput
              (click)="picker.open()"
              [errorStateMatcher]="matcher"
              formControlName="date"
              [matDatepicker]="picker"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error class="mat-error" *ngIf="validate.date.hasError('required')">
              Please select <strong>Date</strong>
            </mat-error>
          </mat-form-field>
        </div> -->
      <!-- <div
        class="col-lg-3 col-md-1 col-sm-12 col-xs-12 mt-md-0 mt-3 example-full-width-div"
      >
        <mat-form-field
          class="example-full-width"
          appearance="outline"
          style="display: inline"
        >
          <mat-label>Start Date</mat-label>
          <input
            matInput
            formControlName="date"
            placeholder="Choose a Date"
            (click)="picker.open()"
            [matDatepicker]="picker"
          />
          <input
          matInput
          (click)="picker.open()"
          [errorStateMatcher]="matcher"
          formControlName="date"
          [matDatepicker]="picker"
        />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      
      </div> -->

      <!-- <div class="col-md-1 col-sm-12 button-style">
          <button
            mat-flat-button
            type="button"
            class="normal-button"
            (click)="search()"
          >
            Search
          </button>
        </div>
        <div class="col-md-2 col-sm-12 clear-m button-style">
          <button
            type="reset"
            mat-flat-button
            (click)="clear()"
            class="clear-button"
          >
            Clear
          </button>
        </div>
      </div> -->
      <form class="form" [formGroup]="OTAssignfilterForm">
        <div>
          <div
            class="col-lg-2 col-md-1 col-sm-12 col-xs-12 mt-md-0 mt-3 example-full-width-div"
          >
            <mat-form-field
              class="example-full-width"
              appearance="outline"
              style="display: inline"
            >
              <mat-label>Start Date</mat-label>
              <!-- <input
            matInput
            formControlName="date"
            placeholder="Choose a Date"
            (click)="picker.open()"
            [matDatepicker]="picker"
          /> -->
              <input
                matInput
                (click)="picker.open()"
                (dateChange)="startdate($event)"
                [errorStateMatcher]="matcher"
                formControlName="date"
                [matDatepicker]="picker"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
             
            </mat-form-field>
            <mat-error class="date-error" *ngIf="validate.date.touched && validate.date.hasError('required')|| emptyIsNull">
              Please select <strong>Date</strong>
            </mat-error>
         
          </div>
          <div class="col-md-1 col-sm-12 button-style">
            <button
              mat-flat-button
              type="button"
              class="normal-button"
              (click)="search()"
            >
              Search
            </button>
          </div>

          <div class="col-md-2 col-sm-12 clear-m button-style">
            <button
              type="reset"
              mat-flat-button
              (click)="clear()"
              class="clear-button"
            >
              Clear
            </button>
          </div>
        </div>
      </form>
      <div class="col-md-12 col-lg-8 col-md-8 mb-3">
        <div class="float-right" *ngIf="filterData.length > 0">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Search</mat-label>
            <input
              matInput
              (input)="applyFilter($event); validateSpaces($event)"
              placeholder=" Employee Name/Number"
            />
          </mat-form-field>
        </div>
      </div>
      <div
        style="margin-top: 30px !important"
        class="table-responsive mat-elevation-z8 mt-5"
        *ngIf="filterData.length > 0"
      >
        <table class="" mat-table [dataSource]="dataSource">
          <div class="col-md-12">
            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef class="col-md-1 col-sm-1">
                <b>S NO</b>
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ currentPageOffset + i + 1 }}
              </td>
            </ng-container>

            <ng-container matColumnDef="username">
              <th mat-header-cell *matHeaderCellDef class="col-md-2 col-sm-2">
                <b>Emp No/Name</b>
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                style="white-space: nowrap"
              >
                {{ element.employee.employeeNumber }} -
                {{ element?.employee?.user?.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="otdate">
              <th mat-header-cell *matHeaderCellDef class="col-md-2 col-sm-2">
                <b>OT Date</b>
              </th>
              <td mat-cell *matCellDef="let element">{{ element?.otDate }}</td>
            </ng-container>
            <ng-container matColumnDef="otHours">
              <th mat-header-cell *matHeaderCellDef class="col-md-2 col-sm-2">
                <b>OT Hours</b>
              </th>
              <td mat-cell *matCellDef="let element">{{ element?.otHours }}</td>
            </ng-container>
          </div>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell"
              colspan="4"
              align="center"
              style="height: 20px; vertical-align: middle; padding: 0"
            >
              <div
                class="alert alert-secondary d-flex justify-content-center align-items-center"
                style="height: 100%; margin: 0"
              >
                <h3 style="font-size: 14px; margin: 0">No Data</h3>
              </div>
            </td>
          </tr>
        </table>

        <mat-paginator
          [hidden]="filterData.length < 5"
          [length]="filterData.length"
          [pageSize]="5"
          [pageSizeOptions]="[5, 10, 20, 30, 50, 100]"
          showFirstLastButtons
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </div>
      
      
    </div>
  </div>
  <div class="p-3 noData mt-5" *ngIf="nodata">
    <div class="no-data card text-center">
      <div class="card-body">No Data</div>
    </div>
  </div>
  
</div>
